import PaymentIcon from '@material-ui/icons/Payment';

import { RevenueAndExpensesList } from './List/List';


export const financialStatementsResource = {
	list: RevenueAndExpensesList,
	icon: PaymentIcon,
};
